
import { mapState, mapGetters, mapActions } from "vuex";
import {
  mdiCheckboxBlankCircle,
  mdiCheckboxBlankCircleOutline,
  mdiWeb,
  mdiLinkVariant,
  mdiChevronRight,
  mdiOpenInNew,
} from "@mdi/js";
import vClickOutside from "v-click-outside";
import {
  spacesToDashes,
  getMessengerLink,
  externalProfileLink,
} from "~/common/helpers";
import {
  filterProfileServices,
  resolveServiceCatalogPath,
} from "~/common/seo/service-catalog-url";

import ratesModal from "~/components/v2/modals/profiles/rates-modal.vue";
import messageMenu from "~/components/v2/message/message-menu.vue";
import servicesModal from "~/components/v2/modals/profiles/services-modal.vue";
import IconCalendarCheck from "~/components/v2/icons/IconCalendarCheck.vue";
import cScrollBtn from "~/components/v2/ui/c-scroll-btn.vue";
import ProfileContactInfo from "~/components/v2/profile-contact-info.vue";

const weekDays = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },

  components: {
    ratesModal,
    messageMenu,
    servicesModal,
    IconCalendarCheck,
    cScrollBtn,
    ProfileContactInfo,
  },

  filters: {
    createLinkName(link) {
      if (link.startsWith("http")) {
        return link.split("//")[1].split("/")[0].replace("www.", "");
      } else if (!link.startsWith("@")) {
        return "@" + link;
      } else {
        return link;
      }
    },
  },

  props: ["profile", "mobileGalleryTab"],

  data() {
    return {
      slug: this.$route.params.slug,

      mdiCheckboxBlankCircle,
      mdiCheckboxBlankCircleOutline,
      mdiWeb,
      mdiLinkVariant,
      mdiChevronRight,
      mdiOpenInNew,

      openedTabs: [0, 1, 2, 3, 4, 5],

      isFavorite: false,
      isFavoritesLoading: false,

      dateFormatOptions: {
        day: "numeric",
        month: "numeric",
      },

      showScrollButton: false,
    };
  },

  computed: {
    ...mapState(["menus"]),

    ...mapGetters({
      discreetMode: "getDiscreetStatus",
      favouritesProfiles: "favourites/getFavouritesModels",
      isMobile: "global/getMobileStatus",
      filtersList: "profiles/getFiltersList",
      currentCity: "global/getCurrentCity",
      schedule: "profile-schedule/getSchedule",
    }),

    rates() {
      const rates = {};
      if (this.availableForIncall) {
        rates.incallRates = this.incallRates;
      }
      if (this.availableForOutcall) {
        rates.outcallRates = this.outcallRates;
      }
      if (this.availableForOnline) {
        rates.onlineRates = this.onlineRates;
      }
      return rates;
    },

    nationality() {
      if (!this.profile.myDetails) return null;
      return this.filtersList.nationality[
        +this.profile.myDetails[0].nationality
      ];
    },

    ethnicity() {
      if (!this.profile.myDetails || !this.profile.myDetails[0]) return null;
      return this.profile.myDetails[0].ethnicity;
    },

    nationalityUrl() {
      const cityUrl = spacesToDashes(this.profile.location[0].baseCity);
      return (
        "/" +
        cityUrl +
        "/" +
        this.profile.gender.toLocaleLowerCase() +
        "/" +
        this.nationality.toLocaleLowerCase().replace(/ |\//g, "-") +
        "-escorts"
      ).replace(/[-]{2,}/g, "-");
    },

    ethnicityUrl() {
      if (!this.profile.myDetails || !this.profile.myDetails[0]) return null;

      const cityUrl = spacesToDashes(this.profile.location[0].baseCity);
      let ethnicity =
        spacesToDashes(
          this.splitBrackets(this.profile.myDetails[0].ethnicity.toLowerCase())
            .replace("(", "")
            .replace(")", "")
            .replace(" / ", "-")
            .replace("/", "-")
        ) + "-escorts";
      return (
        "/" +
        cityUrl +
        "/" +
        this.profile.gender.toLocaleLowerCase() +
        "/" +
        ethnicity
      ).replace(/[-]{2,}/g, "-");
    },

    availableForIncall() {
      return this.profile.aboutMe[0].availableFor.includes("Incall");
    },

    availableForOutcall() {
      return this.profile.aboutMe[0].availableFor.includes("Outcall");
    },

    availableForOnline() {
      return this.profile.aboutMe[0].availableFor.includes("Online");
    },

    incallRates() {
      return this.profile.serviceDetails[0].companionshipRates.filter(
        (rate) => rate.price_service_id == 1
      );
    },

    outcallRates() {
      return this.profile.serviceDetails[0].companionshipRates.filter(
        (rate) => rate.price_service_id == 2
      );
    },

    onlineRates() {
      return this.profile.serviceDetails[0].companionshipRates.filter(
        (rate) => rate.price_service_id == 3
      );
    },

    ProfileNav() {
      return this.menus.ProfileNav;
    },

    isMobile() {
      return this.$store.state.global.mobile;
    },

    profileToContextMenu() {
      return this.profile;
    },

    services() {
      return filterProfileServices(this.profile?.services);
    },

    shortProfileInfo() {
      const prices = this.profile.serviceDetails[0].companionshipRates.slice(
        0,
        3
      );
      const services = this.services.slice(0, 6);
      return {
        prices,
        serviceFor: this.profile.serviceDetails[0].serviceFor,
        services,
        availableFor: this.profile.aboutMe[0].availableFor,
      };
    },

    hideServiceDetailsTab() {
      return this.isMobile && !this.services.length;
    },

    serviceDetails() {
      return this.profile?.serviceDetails[0];
    },

    tourList() {
      return this.serviceDetails?.tours || [];
    },

    isShowPm() {
      return !this.profile.is_own_profile;
    },

    cityCatalogUrl() {
      return `/${spacesToDashes(
        this.profile.location[0].baseCity
      )}/${this.profile.gender.toLocaleLowerCase()}`;
    },

    hairColor() {
      if (!this.profile.myDetails || !this.profile.myDetails[0]) return null;
      return this.profile.myDetails[0].hairColor;
    },

    hairColorUrl() {
      if (!this.profile.myDetails || !this.profile.myDetails[0]) return null;
      const cityUrl = spacesToDashes(this.profile.location[0].baseCity);
      const hairColorUrls = {
        Blonde: `/${cityUrl}/${this.profile.gender.toLocaleLowerCase()}/blonde-escorts`,
        Black: `/${cityUrl}/${this.profile.gender.toLocaleLowerCase()}/blackhairs-escorts`,
        Brunette: `/${cityUrl}/${this.profile.gender.toLocaleLowerCase()}/brunette-escorts`,
        Red: `/${cityUrl}/${this.profile.gender.toLocaleLowerCase()}/redhead-escorts`,
      };
      return hairColorUrls[this.profile.myDetails[0].hairColor];
    },

    breast() {
      if (!this.profile.myDetails || !this.profile.myDetails[0]) return null;
      return this.profile.myDetails[0].breast;
    },

    breastUrl() {
      if (!this.profile.myDetails || !this.profile.myDetails[0]) return null;
      const cityUrl = spacesToDashes(this.profile.location[0].baseCity);
      const breastUrls = {
        Silicone: `/${cityUrl}/${this.profile.gender.toLocaleLowerCase()}/silicone-breast`,
        Natural: `/${cityUrl}/${this.profile.gender.toLocaleLowerCase()}/natural-breast`,
      };
      return breastUrls[this.profile.myDetails[0].breast];
    },

    serviceForUrls() {
      const cityUrl = spacesToDashes(this.profile.location[0].baseCity);
      return {
        Woman: `/${cityUrl}/${this.profile.gender.toLocaleLowerCase()}/for-woman-services-escorts`,
        Man: `/${cityUrl}/${this.profile.gender.toLocaleLowerCase()}/for-man-services-escorts`,
        Couples: `/${cityUrl}/${this.profile.gender.toLocaleLowerCase()}/for-couples-services-escorts`,
      };
    },

    availableForUrls() {
      const cityUrl = spacesToDashes(this.profile.location[0].baseCity);
      return {
        Incall: `/${cityUrl}/${this.profile.gender.toLocaleLowerCase()}/incall-services-escorts`,
        Outcall: `/${cityUrl}/${this.profile.gender.toLocaleLowerCase()}/outcall-services-escorts`,
        Online: `/${cityUrl}/${this.profile.gender.toLocaleLowerCase()}/online-services-escorts`,
      };
    },

    bigAssUrl() {
      const cityUrl = spacesToDashes(this.profile.location[0].baseCity);
      return `/${cityUrl}/${this.profile.gender.toLocaleLowerCase()}/big-ass`;
    },

    bbwUrl() {
      const cityUrl = spacesToDashes(this.profile.location[0].baseCity);
      return `/${cityUrl}/${this.profile.gender.toLocaleLowerCase()}/bbw-escorts`;
    },

    bigBoobUrl() {
      const cityUrl = spacesToDashes(this.profile.location[0].baseCity);
      return `/${cityUrl}/${this.profile.gender.toLocaleLowerCase()}/big-boobs-escorts`;
    },

    petiteUrl() {
      const cityUrl = spacesToDashes(this.profile.location[0].baseCity);
      return `/${cityUrl}/${this.profile.gender.toLocaleLowerCase()}/petite-escorts`;
    },

    skinnyUrl() {
      const cityUrl = spacesToDashes(this.profile.location[0].baseCity);
      return `/${cityUrl}/${this.profile.gender.toLocaleLowerCase()}/skinny-escorts`;
    },

    slimUrl() {
      const cityUrl = spacesToDashes(this.profile.location[0].baseCity);
      return `/${cityUrl}/${this.profile.gender.toLocaleLowerCase()}/slim-escorts`;
    },

    firstDistrict() {
      return this.profile.location[0]?.districts?.at(0);
    },

    restDistricts() {
      return this.profile.location[0]?.districts?.slice(1) || [];
    },

    timesByDay() {
      if (this.schedule) {
        const times = {};
        this.availableWeekDays.forEach((day) => {
          let from = this.schedule[`${day}_time_from`];
          let to = this.schedule[`${day}_time_to`];

          from = from ? from.slice(0, 5) : "00:00";
          to = to ? to.slice(0, 5) : "23:59";

          times[day] = [from, to];
        });
        return times;
      }
      return {};
    },

    availableWeekDays() {
      if (this.schedule) {
        const weekDaysMap = new Set();
        Object.keys(this.schedule).forEach((k) => {
          if (this.schedule[k]) {
            const dayKey = k.split("_")[0];
            if (weekDays.includes(dayKey)) {
              weekDaysMap.add(dayKey);
            }
          }
        });
        return Array.from(weekDaysMap);
      }
      return [];
    },
  },

  mounted() {
    // window.addEventListener("scroll", this.processScroll, { passive: true });
    if (!this.isMobile) {
      this.openTab(0);
    }
    this.isFavorite = this.profile.isFavorite;

    this.$root.$on("open-services-modal", () => {
      this.openServicesModal();
    });

    this.$root.$on("open-rates-modal", () => {
      this.openRatesModal();
    });

    this.$nextTick(() => {
      setTimeout(() => {
        this.setExpandMenuHeight();
        this.setupScrollListener();
      }, 500);
    });
  },

  beforeDestroy() {
    const expandMenu = document.querySelector(".profile-sidebar__expand-menu");
    if (expandMenu) {
      expandMenu.removeEventListener("scroll", this.checkScrollPosition);
    }
  },

  methods: {
    ...mapActions({
      addToFafourites: "profiles/addToFafourites",
      removeFromFavourites: "profiles/removeFromFavourites",
    }),

    externalProfileLink,

    splitBrackets(str) {
      return str.replace(/(\w+)(\(\w+\))/g, "$1 $2");
    },

    async processFavorites() {
      if (!this.$auth.loggedIn) {
        this.redirectAuth();
        return;
      }
      try {
        this.isFavoritesLoading = true;
        let response;
        if (this.isFavorite) {
          response = await this.removeFromFavourites(this.profile.id);
          if (response.data.status) this.isFavorite = false;
        } else {
          response = await this.addToFafourites(this.profile.id);
          if (response.data.status) this.isFavorite = true;
        }

        if (!response.data.status) {
          this.$notify({
            type: "warning",
            message: response.data.msg,
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isFavoritesLoading = false;
      }
    },

    // processScroll() {
    //   if (this.$store.state.global.mobile) return;
    //   const control = this.$refs.control;
    //   const sidebar = this.$refs.prof;
    //   const controlTrigger = this.$refs.controlTrigger;
    //   if (control && controlTrigger) {
    //     control.classList.toggle("flex", window.pageYOffset > 500);
    //     sidebar.classList.toggle(
    //       "btn-fixed",
    //       window.pageYOffset > controlTrigger.offsetTop
    //     );
    //     control.classList.toggle(
    //       "unFixed",
    //       window.pageYOffset > controlTrigger.offsetTop
    //     );
    //   }
    // },

    openTab(tabIndex) {
      if (this.openedTabs.includes(tabIndex)) {
        return;
      }
      this.openedTabs.push(tabIndex);
    },

    tagToUrl(tag) {
      return resolveServiceCatalogPath({
        cityName: this.profile.location[0].baseCity,
        gender: this.profile.gender,
        slug: tag,
      });
    },

    districtCatalogUrl(district) {
      const cityUrl = spacesToDashes(this.profile.location[0].baseCity);
      const districtUrl = "-" + spacesToDashes(district);

      return (
        "/" +
        cityUrl +
        districtUrl +
        "/" +
        this.profile.gender.toLocaleLowerCase()
      );
    },

    getMessengerLink,

    openServicesModal() {
      this.$refs.servicesModal.open();
    },

    openRatesModal() {
      this.$refs?.ratesModal?.open();
    },

    setupScrollListener() {
      const expandMenu = document.querySelector(
        ".profile-sidebar__expand-menu"
      );
      if (expandMenu) {
        this.checkScrollPosition();
        expandMenu.addEventListener("scroll", this.checkScrollPosition);
      }
    },

    checkScrollPosition() {
      const expandMenu = document.querySelector(
        ".profile-sidebar__expand-menu"
      );
      if (expandMenu) {
        const isScrollEnd =
          expandMenu.scrollHeight -
            expandMenu.scrollTop -
            expandMenu.clientHeight <
          20;
        this.showScrollButton = !isScrollEnd;
      }
    },

    redirectAuth() {
      if (window.innerWidth < 1024) {
        this.$root.$emit("sign-in-drawer:open");
      } else {
        this.$router.push({ name: "auth-signin" });
      }
    },

    setExpandMenuHeight() {
      if (window.innerWidth < 993) return;

      const expandMenu = document.querySelector(
        ".profile-sidebar__expand-menu"
      );

      const navigation = document.querySelector(".navigation");
      const profileGallery = document.querySelector(".profile-gallery");
      const subscribeForm = document.querySelector(".subscribe-form");

      if (expandMenu && navigation && profileGallery && subscribeForm) {
        const height =
          navigation.offsetHeight +
          profileGallery.offsetHeight +
          subscribeForm.offsetHeight;
        expandMenu.style.maxHeight = height + 79 + "px";
      }
    },

    openBookMeModal() {
      console.log("openBookMeModal");
      this.$root.$emit("book-me-modal:open", this.profile);
    },

    scroll() {
      const expandMenu = document.querySelector(
        ".profile-sidebar__expand-menu"
      );
      if (expandMenu) {
        expandMenu.scrollBy({
          top: expandMenu.scrollHeight,
          behavior: "smooth",
        });
      }
    },
  },
};
